import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

import AccountSummaryWeb from './components/AccountSummaryWeb';
import AccountSummaryMobile from './components/AccountSummaryMobile';

const AccountSummary = ({ userData }) => (
  <Row>
    <Col xs={{ span: '0' }} sm={{ span: '0' }} lg={{ span: '24' }}>
      <AccountSummaryWeb userData={userData} />
    </Col>
    <Col sm={{ span: '24' }} lg={{ span: '0' }}>
      <AccountSummaryMobile userData={userData} />
    </Col>
  </Row>
);

export default AccountSummary;

AccountSummary.propTypes = {
  userData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
};
